import { useSelector } from "react-redux";
import { selectArchiveTerms } from "../../../../store/selectors/DataSelectors";
import { Text, View, Link } from "@react-pdf/renderer";
import * as React from "react";
import { Fragment } from "react";
import { marked } from 'marked';
import { styles } from "../../index";

marked.use({
  gfm: true,
  breaks: true,
});

const renderInline = (tokens: any[]): React.ReactNode[] => {
  if (!tokens) return [];
  return tokens.map((token: any, i: number) => {
    switch (token.type) {
      case 'text':
        if (token.tokens) {
          return <Fragment key={i}>{renderInline(token.tokens)}</Fragment>;
        }
        return token.text;
      case 'strong':
        return <Text key={i} style={styles.bold}>{renderInline(token.tokens)}</Text>;
      case 'link':
        return <Link key={i} src={token.href} style={{ color: '#0056b3' }}>{renderInline(token.tokens)}</Link>;
      case 'em':
        return <Text key={i}>{renderInline(token.tokens)}</Text>;
      case 'br':
        return <Text key={i}>{'\n'}</Text>;
      default:
        return token.raw || '';
    }
  });
};

const renderBlock = (tokens: any[]): React.ReactNode[] => {
  return tokens.map((token: any, i: number) => {
    switch (token.type) {
      case 'paragraph':
        return (
          <Text key={i} style={{ marginBottom: '3mm' }}>
            {renderInline(token.tokens)}
          </Text>
        );
      case 'list': {
        const start = token.start || 1;
        return (
          <View key={i} style={{ marginBottom: '3mm', paddingLeft: '5mm' }}>
            {token.items.map((item: any, j: number) => {
              const inlineTokens = item.tokens.flatMap((t: any) => t.tokens || [t]);
              return (
                <View key={j} style={{ flexDirection: 'row', marginBottom: '2mm' }}>
                  <Text style={{ width: token.ordered ? '7mm' : '5mm' }}>
                    {token.ordered ? `${start + j}. ` : '\u2022 '}
                  </Text>
                  <Text style={{ flex: 1 }}>
                    {renderInline(inlineTokens)}
                  </Text>
                </View>
              );
            })}
          </View>
        );
      }
      case 'space':
        return <Text key={i}>{'\n'}</Text>;
      default:
        return <Text key={i}>{token.raw}</Text>;
    }
  });
};

const ArchiveOrderPdfDetails = () => {
  const terms = useSelector(selectArchiveTerms);
  const tokens = marked.lexer(terms);
  return (
    <View style={{ fontSize: '9pt', lineHeight: 1.2 }}>
      {renderBlock(tokens)}
    </View>
  );
}

export default ArchiveOrderPdfDetails;
